import { PROFILE_KEY } from '../../../../../models/profile/constants'
import { updateProfileAction } from '../update'
import { PROFILES_ACTION } from '../../constants'

export function updateTrainingFrequencyProfileAction (value) {
  return (dispatch) => {
    dispatch(updateProfileAction({
      type: PROFILES_ACTION.UPDATE_TRAINING_FREQUENCY,
      payload: {
        key: PROFILE_KEY.TRAINING_FREQUENCY,
        value
      }
    }))
  }
}
